import { Injectable } from '@angular/core';
import type { ItemsService } from '@app/@classes/abstract/items-service-interface';
import { ItemsTableServiceBase } from '@app/@classes/abstract/items-table-service';
import type { Tables } from '@app/@classes/supabase';
import { Observable, from, of, take } from 'rxjs';

const TABLE = 'notifications';
type T = typeof TABLE;
type NotificationOffice =
  | 'warehouse'
  | 'administration'
  | 'planning'
  | 'customer-portal';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService
  extends ItemsTableServiceBase<Tables<T>>
  implements ItemsService<Tables<T>>
{
  constructor() {
    super(TABLE, { hasTenant: true });
  }

  markAllAsRead(office: NotificationOffice): Observable<void> {
    if (office === 'planning' || office === 'customer-portal') {
      return of(void 0);
    }

    // La marcatura avviene lato backend (Fastify/tRPC): un'unica UPDATE
    // filtrata per ufficio, invece di leggere gli id e riscriverli uno a uno.
    return from(
      this.trpcService.client.notifications.markAllAsRead.mutate({ office }),
    ).pipe(take(1));
  }

  /**
   * Crea una notifica (bucket Magazzino) quando un magazziniere stampa dal
   * palmare il DDT ricevuto dal gestionale esterno.
   */
  notifyExternalDdtPrinted(outgoingOrderId: string): Observable<void> {
    return from(
      this.trpcService.client.notifications.notifyExternalDdtPrinted.mutate({
        outgoingOrderId,
      }),
    ).pipe(take(1));
  }

  override defaultItem(): Tables<T> {
    return {
      alert_id: null,
      created_at: null,
      created_by: null,
      deadline_id: null,
      outgoing_order_id: null,
      id: this.randomUUID(),
      is_read: false,
      message: null,
      read_at: null,
      tenant_id: '',
      title: null,
      updated_at: null,
      updated_by: null,
      user_id: null,
    };
  }
}
